export default [
    {
        path: '/user/work-location/summary',
        props: true,
        component: () => import('@/views/User/WorkLocation/Summary.vue'),
    },
];
